import { esCCFMismoDia, getTipoDocumentoTexto } from "../../../components/utils/invoiceValidation";

export default function AnularInvoiceModal({
  show,
  invoice,
  motivo,
  isAnulando,
  onMotivoChange,
  onAnular,
  onClose
}) {
  if (!show || !invoice) return null;

  const puedeAnular = esCCFMismoDia(invoice);
  const tipoDocumento = getTipoDocumentoTexto(invoice.tipo_documento);

  return (
    <>
      <div className="modal fade show d-block">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content card">

            {/* Header */}
            <div className="card-header" style={{ 
              background: '#fee2e2', 
              borderBottom: '2px solid #ef4444',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <h3 className="card-title" style={{ margin: 0, color: '#991b1b' }}>
                🗑️ Anular Factura
              </h3>
              <button
                className="btn btn-secondary btn-sm"
                onClick={onClose}
                style={{ 
                  width: '32px', 
                  height: '32px', 
                  padding: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                ✕
              </button>
            </div>

            {/* Body */}
            <div className="card-body">
              {/* Información de la factura */}
              <div style={{
                background: '#fef3c7',
                border: '1px solid #f59e0b',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '20px'
              }}>
                <div style={{ 
                  display: 'grid', 
                  gridTemplateColumns: 'auto 1fr',
                  gap: '8px 12px',
                  fontSize: '14px'
                }}>
                  <strong>Factura:</strong>
                  <span>{invoice.numero_control}</span>
                  
                  <strong>Cliente:</strong>
                  <span>{invoice.sale?.client?.nombre || "N/A"}</span>
                  
                  <strong>Tipo:</strong>
                  <span>{tipoDocumento}</span>
                  
                  <strong>Fecha emisión:</strong>
                  <span>{new Date(invoice.fecha_emision).toLocaleDateString('es-SV')}</span>
                </div>
              </div>

              {/* Advertencia CCF fuera de plazo */}
              {invoice.tipo_documento === '03' && !puedeAnular && (
                <div style={{
                  background: '#fee2e2',
                  border: '2px solid #ef4444',
                  borderRadius: '8px',
                  padding: '16px',
                  marginBottom: '20px'
                }}>
                  <div style={{ display: 'flex', gap: '12px', alignItems: 'start' }}>
                    <span style={{ fontSize: '24px' }}>⚠️</span>
                    <div>
                      <strong style={{ color: '#991b1b', display: 'block', marginBottom: '4px' }}>
                        ADVERTENCIA
                      </strong>
                      <p style={{ margin: 0, fontSize: '14px', color: '#7f1d1d' }}>
                        Esta es una factura de Crédito Fiscal y NO es del día de hoy.
                        <br />
                        <strong>No se puede anular.</strong> Debes emitir una Nota de Crédito.
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {/* Info CCF mismo día */}
              {invoice.tipo_documento === '03' && puedeAnular && (
                <div style={{
                  background: '#dbeafe',
                  border: '1px solid #3b82f6',
                  borderRadius: '8px',
                  padding: '16px',
                  marginBottom: '20px'
                }}>
                  <div style={{ display: 'flex', gap: '12px', alignItems: 'start' }}>
                    <span style={{ fontSize: '20px' }}>ℹ️</span>
                    <p style={{ margin: 0, fontSize: '14px', color: '#1e40af' }}>
                      Las facturas de <strong>Crédito Fiscal</strong> solo se pueden anular el mismo día de emisión.
                    </p>
                  </div>
                </div>
              )}

              {/* Info Consumidor Final */}
              {invoice.tipo_documento === '01' && (
                <div style={{
                  background: '#dbeafe',
                  border: '1px solid #3b82f6',
                  borderRadius: '8px',
                  padding: '16px',
                  marginBottom: '20px'
                }}>
                  <div style={{ display: 'flex', gap: '12px', alignItems: 'start' }}>
                    <span style={{ fontSize: '20px' }}>ℹ️</span>
                    <p style={{ margin: 0, fontSize: '14px', color: '#1e40af' }}>
                      Las facturas de <strong>Consumidor Final</strong> se pueden anular en cualquier momento.
                    </p>
                  </div>
                </div>
              )}

              {/* Textarea motivo */}
              <div className="form-group" style={{ marginBottom: '20px' }}>
                <label className="form-label" style={{ fontWeight: 600, marginBottom: '8px', display: 'block' }}>
                  Motivo de Anulación *
                </label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Describe el motivo de anulación (mínimo 10 caracteres)..."
                  value={motivo}
                  onChange={(e) => onMotivoChange(e.target.value)}
                  disabled={!puedeAnular}
                  style={{
                    fontSize: '14px',
                    resize: 'none'
                  }}
                />
                <small style={{ color: '#718096', fontSize: '13px' }}>
                  {motivo.length}/500 caracteres
                </small>
              </div>

              {/* Advertencia final */}
              <div style={{
                background: '#fee2e2',
                border: '1px solid #ef4444',
                borderRadius: '8px',
                padding: '16px'
              }}>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'start' }}>
                  <span style={{ fontSize: '20px' }}>⚠️</span>
                  <div>
                    <strong style={{ color: '#991b1b', display: 'block', marginBottom: '4px', fontSize: '14px' }}>
                      Esta acción no se puede deshacer
                    </strong>
                    <p style={{ margin: 0, fontSize: '14px', color: '#7f1d1d' }}>
                      La factura será reportada como anulada ante el Ministerio de Hacienda.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="card-body" style={{ 
              borderTop: '2px solid #e2e8f0',
              display: 'flex',
              gap: '12px',
              paddingTop: '16px'
            }}>
              <button
                className="btn btn-secondary"
                onClick={onClose}
                style={{ flex: 1 }}
                disabled={isAnulando}
              >
                Cancelar
              </button>

              <button
                className="btn btn-danger"
                onClick={onAnular}
                disabled={isAnulando || motivo.trim().length < 10 || !puedeAnular}
                style={{ flex: 1 }}
              >
                {isAnulando ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Anulando...
                  </>
                ) : (
                  '🗑️ Confirmar Anulación'
                )}
              </button>
            </div>

          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
}